import { useQuery } from "@tanstack/react-query";

import { readProjectFiles } from "../../../services/projects";

type ReadProjectFiles = {
    projectId: string;
};

export type DataProjectFile = {
    created_at: string;
    id_e: string;
    name: string;
    project_id_e: string;
    type: string;
    updated_at: string;
    url: string;
    wasMigrated: boolean;
};

export type TReadProjectFilesResponse = {
    data: DataProjectFile[];
};

export function useReadProjectFiles({ projectId }: ReadProjectFiles) {
    return useQuery<
        TReadProjectFilesResponse,
        unknown,
        TReadProjectFilesResponse
    >({
        enabled: true,
        queryKey: [`readProjectFiles`],
        queryFn: () => readProjectFiles({ projectId }),
        refetchOnMount: "always",
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
    });
}
